import React, { useRef } from "react";
import { useGLTF, PerspectiveCamera } from "@react-three/drei";

export function Model(props) {
  const { nodes, materials } = useGLTF("/sc_one_scene.glb");
  return (
    <group {...props} dispose={null}>
      <PerspectiveCamera
        makeDefault={true}
        far={1000}
        near={0.1}
        fov={22.89519205}
        position={[4.11820221, 3.03079867, -2.43946123]}
        rotation={[-2.32453005, 0.85733481, 2.46346646]}
      />
      <mesh
        geometry={nodes.headrest001.geometry}
        material={materials.MA_Metal1}
        position={[-0.00020431, 0.99097365, 0.44799578]}
        rotation={[-1.45310946, -4e-8, -Math.PI]}
        scale={[0.66370666, 0.66203618, 0.53112513]}
      />
      <mesh
        geometry={nodes["back-support001"].geometry}
        material={materials.MA_Metal1}
        position={[-0.00020434, 0.49537587, 0.37875861]}
        rotation={[-1.45310946, -4e-8, -Math.PI]}
        scale={0.66370666}
      >
        <mesh
          geometry={nodes["BACK-cushion001"].geometry}
          material={materials["MA-Alcantara"]}
          position={[-0.00000255, -0.01634391, 0.0066166]}
          scale={[1, 0.96261728, 1]}
        >
          <mesh
            geometry={nodes["stitch-ORIGINAL001"].geometry}
            material={materials["MA-Stitching"]}
            position={[0.00026796, -0.01714711, -0.03674684]}
            rotation={[1.68855461, 0, 0]}
            scale={[1, 1.00054622, 1.03830934]}
          />
        </mesh>
      </mesh>
      <mesh
        geometry={nodes.Legs001.geometry}
        material={materials.MA_Metal1}
        position={[-0.00020441, -0.14011101, -0.01981783]}
        rotation={[-Math.PI, 0, 0]}
        scale={[0.66370666, 0.66370666, 0.88427466]}
      />
      <mesh
        geometry={nodes["air-back001"].geometry}
        material={materials.MA_Metal2}
        position={[-0.00019215, 0.5927462, 0.46367091]}
        rotation={[Math.PI, -9e-8, Math.PI]}
        scale={0.66370666}
      />
      <mesh
        geometry={nodes.mechanics001.geometry}
        material={materials.MA_Metal2}
        position={[0.00034203, -0.08360338, -0.04821429]}
        rotation={[Math.PI, -9e-8, Math.PI]}
        scale={[0.19368733, 0.02104394, 0.2957862]}
      />
      <mesh
        geometry={nodes["seat-base001"].geometry}
        material={materials.MA_Metal1}
        position={[-0.0002044, 0.00637395, -0.16901624]}
        rotation={[-Math.PI / 2, -4e-8, -Math.PI]}
        scale={0.6637066}
      />
      <mesh
        geometry={nodes.tree001.geometry}
        material={materials["MASE-METAL.002"]}
        position={[2.73728299, 1.03762662, 4.09884405]}
        scale={0.77475619}
      />
      <mesh
        geometry={nodes["stitch-seat001"].geometry}
        material={materials["MA-Stitching"]}
        position={[-0.00058777, 0.03900254, -0.1726822]}
        rotation={[Math.PI, -9e-8, Math.PI]}
        scale={0.66370666}
      />
      <group
        position={[-0.00023427, 0.11223564, 0.10405546]}
        rotation={[Math.PI, -9e-8, Math.PI]}
        scale={0.68103689}
      >
        <mesh
          geometry={nodes.item001.geometry}
          material={materials["MA-mb-Logo"]}
        />
        <mesh
          geometry={nodes.item001_1.geometry}
          material={materials["MA-logo-back"]}
        />
        <mesh
          geometry={nodes.item001_2.geometry}
          material={materials.carbon_0}
        />
      </group>
      <mesh
        geometry={nodes.logo_separated001.geometry}
        material={materials["mb-bk-logo"]}
        position={[-1.63931131, 1.65084755, 4.38162088]}
        rotation={[Math.PI / 2, -1.6e-7, Math.PI]}
        scale={0.51759481}
      />
      <mesh
        geometry={nodes.Cube003.geometry}
        material={materials["Material.008"]}
        position={[0.01204322, 0.53584874, 6.16790104]}
      />
      <mesh
        geometry={nodes.rock002.geometry}
        material={materials["Material.005"]}
        position={[2.33651876, -0.35283798, 3.04944062]}
        rotation={[0, 0, -1.73779303]}
        scale={[0.83307058, 1.04392707, 1.70771039]}
      />
      <mesh
        geometry={nodes.rock003.geometry}
        material={materials["Material.010"]}
        position={[1.83445728, -1.0027734, 9.36371136]}
        rotation={[-2.06994889, 0.32589906, 1.65650232]}
        scale={[3.72814322, 3.49409604, 4.48055267]}
      />
      <mesh
        geometry={nodes["floor-middle001"].geometry}
        material={materials["Material.004"]}
        position={[0, -0.42921683, 0]}
        rotation={[0, 0.5188924, 0]}
      />
      <mesh
        geometry={nodes.Cube005.geometry}
        material={materials["Material.009"]}
        position={[0.32779399, 0.53420424, 6.02063751]}
      />
      <mesh
        geometry={nodes.Cube004.geometry}
        material={materials["Material.006"]}
        position={[-1.94507504, 0.53420424, 4.85819626]}
      />
      <mesh
        geometry={nodes.FICUS_LYRATA_FICUS_LYRATA_Mat_0001.geometry}
        material={materials["Material.007"]}
        position={[1.9078517, -0.64147192, 3.79721594]}
        rotation={[-Math.PI / 2, 2.1e-7, -1.68407414]}
        scale={[0.83338338, 0.83338314, 0.83338332]}
      />
      <mesh
        geometry={nodes.headrest_cushion001.geometry}
        material={materials["MA-Alcantara"]}
        position={[-0.00020438, 0.99448198, 0.43488064]}
        rotation={[Math.PI, -9e-8, Math.PI]}
        scale={0.66370666}
      >
        <mesh
          geometry={nodes["stitch-for-head-good-2001"].geometry}
          material={materials["MA-Stitching"]}
          position={[0.0000418, -0.00252533, -0.00088155]}
        />
      </mesh>
      <mesh
        geometry={nodes["seat-cushion001"].geometry}
        material={materials["MA-Alcantara"]}
        position={[-0.00020315, 0.02007911, -0.17926365]}
        rotation={[Math.PI, -9e-8, Math.PI]}
        scale={0.66370666}
      />
    </group>
  );
}

useGLTF.preload("/sc_one_scene.glb");
